import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    Sy_userName: localStorage.getItem('Sy_userName') ? localStorage.getItem('Sy_userName') : '',
    Sy_userPhone: localStorage.getItem('Sy_userPhone') ? localStorage.getItem('Sy_userPhone') : '',
    Sy_userId: localStorage.getItem('Sy_userId') ? localStorage.getItem('Sy_userId') : '',
  },
  mutations: {
    changeuser(state, user) {
      console.log(user);
      state.Sy_userName = user.user.asuName;
      state.Sy_userPhone = user.user.asuPhone;
      state.Sy_userId = user.user.asuId;
      localStorage.setItem('Sy_userName', user.user.asuName);
      localStorage.setItem('Sy_userPhone', user.user.asuPhone);
      localStorage.setItem('Sy_userId', user.user.asuId);

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
